/*<!-------------------------------------
|   Author: Kartik Mukati          |
|   Date: 24-04-2023                   |
--------------------------------------->*/
import { Component, OnChanges, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { StepBarState, getStepBarState } from '../../../../configurator-app/conf-store/reducer/stepbar.reducer';
import { environment } from '../../../../../environments/environment';


@Component({
  selector: 'app-conf-step-count',
  templateUrl: './conf-step-count.component.html',
  styleUrls: ['./conf-step-count.component.scss']
})
export class ConfStepCountComponent implements OnInit, OnChanges {
  confAWSUrlStr: any = environment.confAWSurl;
  stepBarState: any;
  stepCount: number = 0;
  totalStep: number = 0;
  spinnerTitle: string = "";
  value: number = 0;

  constructor(
    private store: Store<StepBarState>
  ) {
    this.store.pipe(select(getStepBarState))
      .subscribe(data => {
        this.stepBarState = data;
        this.totalStep = this.stepBarState.stepArr.length
        this.stepCount = this.stepBarState.currentStep + 1;
        this.value = (this.stepCount / this.totalStep) * 100;
        this.spinnerTitle = this.stepCount.toString() + '/' + this.totalStep.toString();
      });
  }

  updateprogresscounter: Subscription = new Subscription();


  ngOnInit(): void {

  }

  ngOnChanges(): void {
  }
}
